<template>
  <div>
    <div
      class="text-xs-center pa-2"
      style="border: 1px solid #eee; float: left; border-radius: 10px"
    >
      <vue-simple-svg
        :filepath="'/static/img/assets/get_started/add-menu_list.svg'"
        width="40px"
        height="40px"
        class="img"
        :fill="$vuetify.theme.primary"
      />
      <div class="primary--text caption">Line Flex Message</div>
      <v-btn v-if="isZwizAdmin" color="primary" depressed @click="showLineFlex = true">{{
        $t('Edit')
      }}</v-btn>
      <v-dialog v-model="showLineFlex" width="1000">
        <v-card>
          <v-layout>
            <v-flex>
              <div class="primary--text headline pa-2">Line Flex Message</div>
            </v-flex>
            <v-flex>
              <div class="text-xs-right">
                <v-btn flat fab small @click="cancelAddFlexMessage">
                  <v-icon>close</v-icon>
                </v-btn>
              </div>
            </v-flex>
          </v-layout>

          <v-card-text v-if="message">
            <intent-line-flex-message v-model="message"></intent-line-flex-message>
          </v-card-text>

          <v-card-text class="text-xs-center">
            <v-btn outline color="grey" @click="cancelAddFlexMessage">{{ $t('Cancel') }}</v-btn>
            <v-btn depressed color="primary" @click="saveAddFlexMessage">{{ $t('Save') }}</v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
    <div class="clearfix"></div>
    <div class="caption mt-2 warning--text">
      {{ $t('Note: This messages will not be shown on facebook') }}
    </div>
  </div>
</template>

<script>
import IntentLineFlexMessage from './IntentLineFlexMessage'
export default {
  props: ['value'],
  data: function () {
    return {
      showLineFlex: false,
      message: null,
    }
  },
  components: {
    IntentLineFlexMessage,
  },
  mounted: function () {
    var vm = this
    vm.message = vm.value
    vm.cached_message = JSON.stringify(vm.value)
  },
  methods: {
    cancelAddFlexMessage: function () {
      this.showLineFlex = false
      this.message = JSON.parse(this.cached_message)
    },
    saveAddFlexMessage: function () {
      var vm = this
      vm.$emit('input', vm.message)
      vm.showLineFlex = false
      vm.cached_message = JSON.stringify(vm.message)
    },
  },
  watch: {
    value: function (newVal) {
      this.message = newVal
    },
  },
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/view/intent/IntentLineFlex.vue